import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.startX = 0
    this.startY = 0
    this.isDragging = false
  }

  pointerDown(event) {
    this.startX = event.clientX || (event.touches && event.touches[0].clientX) || 0
    this.startY = event.clientY || (event.touches && event.touches[0].clientY) || 0
    this.isDragging = false
  }

  pointerMove(event) {
    const currentX = event.clientX || (event.touches && event.touches[0].clientX) || 0
    const currentY = event.clientY || (event.touches && event.touches[0].clientY) || 0

    const deltaX = Math.abs(currentX - this.startX)
    const deltaY = Math.abs(currentY - this.startY)

    // If moved more than 5px, consider it a drag/scroll
    if (deltaX > 5 || deltaY > 5) {
      this.isDragging = true
    }
  }

  click(event) {
    // Don't navigate if user was scrolling/dragging
    if (this.isDragging) {
      return
    }

    // Don't navigate if clicking on interactive elements
    const target = event.target
    const isInteractive = target.closest('a, button, input, select, textarea, [data-table-row-ignore]')

    if (isInteractive) {
      return
    }

    // Navigate to the resource URL
    if (this.urlValue) {
      window.location.href = this.urlValue
    }
  }
}
